import {Component, Inject, OnInit, Input, inject, DestroyRef} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';

@Component({
    selector: 'app-external-package-details',
    templateUrl: './external-package-details.component.html',
    styleUrls: ['./external-package-details.component.scss'],
    standalone: false
})
export class ExternalPackageDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  @Input() instance: any;

  expandedElement: any;
  dataSourceInner: any;
  dataSourceInnerPackages: any;
  innerTableColumns: string[] = ['name', 'path', 'currentVersion'];
  dataLoading = true;

  constructor(public sidenavService: SidenavService, @Inject(MAT_DIALOG_DATA) public data: any,
    private solutionsService: SolutionsService, private toastrService: CustomToastrService) {
  }
  
  ngOnInit(): void {
    if (this.data.dataLoaded) {
      this.dataLoading =  false;
    } else {
      this.solutionsService.getReferencePackagesById(this.data.solutionId, this.data.packageReferenceId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(data => {
          this.data.externalPackage = data;
          this.dataLoading = false;
        },
        (error) => {
          this.dataLoading = false;
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
    }
  }

  onArrowClick(data): void {
    this.expandedElement = this.expandedElement === data ? null : data;
    this.data.externalPackage.references.find(item => item.component === data.component).arrowClick = !this.instance?.references?.find(item => item.component === data.component)?.arrowClick;
    this.data?.externalPackage?.references?.forEach(item =>  {
      if(item.component !== data.component) {
        item.arrowClick = false;
      }
    });
    this.dataSourceInner = this.data?.externalPackage?.references?.find(item => item.component === data.component).images;
    this.dataSourceInnerPackages = this.data?.externalPackage?.references?.find(item => item.component === data.component).packages;
  }
}
